// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".infoBox[data-v-1765fd1e] {\n  display: flex;\n  align-items: center;\n  margin-left: 0;\n  margin-bottom: 10px;\n  overflow: hidden;\n  width: 100%;\n}\n.infoBox .input[data-v-1765fd1e] {\n  width: 100px;\n  overflow: hidden;\n  margin: 0 5px;\n}", ""]);
// Exports
module.exports = exports;
